<template>
  <loading v-if="loading" />

  <template v-if="view === 'home'">
    <div id="wrapper" :class="noheader">
      <Banner title="預約掛號" />
      <a
        class="arr"
        v-if="isMobile && notFromLine"
        @click.prevent="$router.replace(from)"
      >
        <div class="inner"></div>
      </a>
      <div class="caption">
        <div class="inner"><p>選擇科別</p></div>
      </div>
      <AppointmentDepts @changeDept="changeDept" />
    </div>
  </template>

  <template v-else-if="view === 'schedule'">
    <div id="wrapper" :class="noheader">
      <Banner title="點選橘色圓鈕進行掛號" />
      <div
        class="caption"
        v-if="member.platform !== 'web'"
        style="margin-bottom: 0px;"
      >
        <!-- <div class="inner"><p>請選擇掛號日期</p></div>-->
      </div>
      <AppointmentDoctors
        :filterDoctor="selectedDoctor"
        @changeDoctor="changeDoctor"
        @backHome="view = 'home'"
        @backAll="selectAll"
      />
      <div class="content reservation">
        <div class="reservationBox">
          <div class="topBox">
            <div class="date">
              {{ currentDate.year }}年 {{ currentDate.month }}月份
            </div>
            <div class="btns">
              <div :class="cssWeek(-1)" @click="changeWeek(-1)">上一週</div>
              <div :class="cssWeek(1)" @click="changeWeek(1)">下一週</div>
            </div>
          </div>
          <div class="calendarBox">
            <div class="txt first"><span>診間</span></div>
            <AppointmentWeek :week="selectedWeek" :weekdates="weekdates" />

            <div class="txt morning bgc">
              <span>上午診</span>
              <span v-if="selectedDoctor.dept === '婦產科'" class="time"
                >9:00 - 12:30 ( 12:00 截止現場掛號、預約報到 )
              </span>
              <span v-if="selectedDoctor.dept === '小兒科'" class="time"
                >9:00 - 12:00 ( 11:30 截止現場掛號、預約報到 )
              </span>
            </div>
            <div class="txt afternoon bgc">
              <span>下午診</span>
              <span v-if="selectedDoctor.dept === '婦產科'" class="time"
                >13:30 - 17:00 ( 16:30 截止現場掛號、預約報到 )
              </span>
              <span v-if="selectedDoctor.dept === '小兒科'" class="time"
                >13:30 - 16:30 ( 16:00 截止現場掛號、預約報到 )
              </span>
            </div>
            <div class="txt night bgc">
              <span>晚上診</span>
              <span v-if="selectedDoctor.dept === '婦產科'" class="time"
                >18:00 - 21:30 ( 21:00 截止現場掛號、預約報到 )</span
              >
              <span v-if="selectedDoctor.dept === '小兒科'" class="time"
                >晚診暫停看診</span
              >
            </div>
            <div class="txt m1"><span>一診</span></div>
            <div class="txt a1"><span>一診</span></div>
            <div class="txt n1"><span>一診</span></div>
            <div class="txt m2 bgc"><span>二診</span></div>
            <div class="txt a2 bgc"><span>二診</span></div>
            <div class="txt n2 bgc"><span>二診</span></div>
            <div class="txt m3"><span>三診</span></div>
            <div class="txt a3"><span>三診</span></div>
            <div class="txt n3"><span>三診</span></div>

            <AppointmentPeriod
              v-for="(s, idx) in filterSchedules"
              :key="idx"
              :period="s"
              @changePeriod="changePeriod"
            />
          </div>
        </div>
        <div class="telBox">
          如有其他需求請來電進行預約&nbsp;<a href="tel:0225012312"
            >02-2501-2312</a
          >
        </div>
      </div>
    </div>
  </template>

  <template v-else-if="view === 'reservation'">
    <div id="wrapper" :class="noheader">
      <Banner title="預約掛號" />
      <a class="arr" @click.prevent="view = 'schedule'"
        ><div class="inner"></div
      ></a>
      <div class="doctorInfo">
        <div class="doctorKV">
          <img
            :src="
              `https://assets.musoon.clinic/images/dr/750x800/${reservation.醫師名}.jpg`
            "
          />
          <div class="cover"></div>
        </div>
        <div class="inner">
          <div class="name">
            <h1>{{ reservation.醫師名 }} {{ reservation.title }}</h1>
            <span>{{ reservation.醫師英名 }}</span>
          </div>
          <div class="info">
            <a @click="btnDoctor(reservation.科別, reservation.醫師名)"
              ><img src="@/assets/images/icon_doctor.svg" /><span
                >醫師相關介紹</span
              ></a
            >
          </div>
          <div class="bookNumber">
            <div class="content">
              <p>您預約號碼</p>
              <div class="number">{{ reservation.就診參考序號 }}</div>
              <p
                v-if="reservation.醫師名 === '張明揚'"
                style="font-size:0.75rem; margin-top:0.8rem; color:red;"
              >
                ＊溫馨提醒您～<br />&nbsp;&nbsp;張醫師僅看婦科
              </p>
              <p
                v-else-if="reservation.醫師名 === '陳思宇'"
                style="font-size:0.75rem; margin-top:0.8rem; color:red;"
              >
                ＊婦科腫瘤及微創手術諮詢門診
              </p>
              <p
                v-else-if="reservation.醫師名 === '李佳珩'"
                style="font-size:0.75rem; margin-top:0.8rem; color:red;"
              >
                ＊溫馨提醒您～<br />&nbsp;&nbsp;李佳珩醫師僅看產科
              </p>
            </div>
          </div>
          <div class="bookInfo">
            <p>
              {{ reservation.科別 }}<br />
              {{ reservation.日期 }}&nbsp;(星期{{
                reservation.day
              }})&nbsp;<br />
              {{ reservation.班別 }}&nbsp;{{ reservation.診別 }}
            </p>
            <span>請確認您的預約時間</span>
          </div>
        </div>
        <div class="btns">
          <a class="btn" @click.prevent="btnForm"><p>確認預約</p></a>
          <a class="btn hollow" @click.prevent="view = 'schedule'"
            ><p>取消</p></a
          >
        </div>
      </div>
    </div>
  </template>

  <template v-else-if="view === 'form'">
    <div id="wrapper" class="noheader signing">
      <a class="arr" @click.prevent="view = 'reservation'"
        ><div class="inner"></div
      ></a>
      <div class="kv login app covershow"><div class="cover"></div></div>
      <div class="content">
        <div class="stepBox">1</div>
        <h1 class="app">線上預約</h1>

        <template v-if="member.info.verified">
          <div class="titleTxt app">
            <div class="inner">
              <span></span>
              <p>請確認預約資料</p>
              <span></span>
            </div>
          </div>
          <div class="formBox">
            <form action="javascript:void(0);">
              <input
                type="text"
                class="inputBox"
                v-model="form['name']"
                disabled
              />
              <input
                type="text"
                class="inputBox"
                v-model="form['birthdate']"
                disabled
              />
              <input
                type="text"
                class="inputBox"
                placeholder="預約備註"
                v-model="form['note']"
              />
              <input
                type="submit"
                class="submitBtn"
                value="確定預約"
                @click.prevent="btnMake"
              />
            </form>
          </div>
        </template>
        <template v-else>
          <div class="titleTxt app">
            <div class="inner">
              <span></span>
              <p>請填寫基本資料</p>
              <span></span>
            </div>
          </div>
          <div class="formBox">
            <form action="javascript:void(0);">
              <input
                type="text"
                class="inputBox"
                placeholder="真實姓名"
                autocomplete="name"
                v-model="form['name']"
              />
              <input
                type="text"
                class="inputBox"
                placeholder="身分證號 / 居留證號 / 護照號碼"
                autocomplete="id"
                v-model="form['twid']"
              />
              <input
                type="text"
                class="inputBox"
                placeholder="出生日期 (西元年月日共八碼)"
                autocomplete="birthday"
                v-model="form['birthdate']"
              />
              <input
                type="text"
                class="inputBox"
                placeholder="手機號碼"
                autocomplete="phone"
                v-model="form['phone']"
              />
              <input
                type="text"
                class="inputBox"
                placeholder="居住地址"
                autocomplete="address"
                v-model="form['address']"
              />
              <select v-model="form['nation']">
                <option disabled value="disabled" selected>請選擇國籍</option>
                <option value="TWN">台灣</option>
                <option value="ZZZ">外籍</option>
              </select>
              <input
                type="text"
                class="inputBox"
                placeholder="預約備註"
                v-model="form['note']"
              />
              <input
                type="submit"
                class="submitBtn"
                value="確定預約"
                @click.prevent="btnMake"
              />
            </form>
          </div>
        </template>
      </div>
    </div>
  </template>

  <template v-else-if="view === 'made'">
    <div id="wrapper" :class="noheader">
      <Banner title="預約掛號" />
      <div class="caption">
        <div class="inner"><p>您已預約完成</p></div>
      </div>
      <div class="content">
        <div v-if="!isMobile">
          <!--網頁版因有Banner會看不到,所以另外再補一個-->
          <div
            style="text-align:center; position: relative; margin-top: -3rem; margin-bottom: 2rem;"
          >
            <p style="color: #494949;">您已預約完成</p>
          </div>
        </div>
        <div class="bookInfoBox">
          <div class="info">
            <div class="bookNumber" style="margin-left: 0px;">
              <div style="text-align: center; " class="content">
                <p>您預約號碼</p>
                <div class="number">
                  {{ appointment.掛號序號 }}
                </div>
                <!-- <br />
                <p
                  v-if="suggestedCheckInTime"
                  style="margin-top: 3.5px; font-size: 1em"
                >
                  建議報到時間 <br /><b style="color: #F09E49;">{{
                    suggestedCheckInTime
                  }}</b>
                </p> -->
              </div>
            </div>
            <div style="text-align:center" class="bookInfo">
              <p>
                {{ reservation.科別 }}<br />
                {{ reservation.日期 }}&nbsp;(星期{{
                  reservation.day
                }})&nbsp;<br />
                {{ reservation.班別 }}&nbsp;{{ reservation.診別 }}
              </p>
              <div class="name">
                <p>{{ reservation.醫師名 }} {{ reservation.title }}</p>
                <span>{{ reservation.醫師英名 }}</span>
              </div>
            </div>
          </div>

          <template
            v-if="member.platform !== 'web' && member.info.verified === 1"
          >
            <div class="qrcodeBox">
              <p class="txt" style="text-align: justify;">
                當日前來看診時：
              </p>
              <br />
              <p class="txt" style="text-align: justify;">
                1. 請掃描一、三樓櫃檯報到機的QR Code報到。
              </p>
              <br />
              <p class="txt" style="text-align: justify;">
                2.
                或點選LINE選單的「首頁」>「就診報到」，於一、三樓櫃檯報到機掃描報到。
              </p>
            </div>
            <AppointmentTimeSlots />
            <div class="btns">
              <a class="btn" @click.prevent="$router.replace('/HomePage')"
                ><p>回首頁</p></a
              >
              <a
                class="btn"
                @click.prevent="$router.replace('/AppointmentQuery')"
                ><p>查詢預約紀錄</p></a
              >
            </div>
          </template>

          <template
            v-if="member.platform !== 'web' && member.info.verified !== 1"
          >
            <div class="description" style="text-align: justify;">
              <ul>
                <li>
                  「初診」：第一次前來看診，請您前來報到時至一樓或三樓櫃檯抽取號碼牌，等候櫃檯叫號辦理門診報到。
                </li>
                <li>
                  「複診」：預約婦產科、小兒科，請您點選右下角加入木生LINE官方好友，進行「帳號綁定」後，當日前來看診時，點選LINE選單的「首頁」>「就診報到」，於自動報到機進行門診報到，自動報到機位置在一樓至三樓的櫃檯有放置。
                </li>
                <li>
                  「複診」：預約麻醉諮詢、超音波影像、快速門診、VIP特約門診、營養諮詢，請您前來報到時至一樓或三樓櫃檯抽取號碼牌，等候櫃檯叫號辦理門診報到。
                </li>
              </ul>
            </div>
            <AppointmentTimeSlots />
            <div class="btns">
              <a class="btn" @click.prevent="$router.replace('/HomePage')"
                ><p>回首頁</p></a
              >
              <a class="btn line" @click.prevent="$router.replace('/SignUp')"
                ><div class="inner">
                  <img src="@/assets/images/icon_line.svg" />
                  <p>LINE帳號綁定</p>
                </div></a
              >
            </div>
            <div>&nbsp;</div>
            <div class="description" style="margin-top: 6px;">
              <p>
                提醒：完成帳號綁定才能查詢預約紀錄喔～感謝您的配合。
              </p>
            </div>
          </template>

          <template v-if="member.platform === 'web'">
            <div class="description">
              <ul style="text-align: justify;">
                <li>
                  「初診」 :
                  第一次前來看診，請您前來報到時至一樓或三樓櫃檯抽取號碼牌，等候櫃檯叫號辦理門診報到。
                </li>
                <li>
                  「複診」 :
                  預約婦產科、小兒科，請您點選右下角加入木生LINE官方好友，進行「帳號綁定」後，當日前來看診時，點選LINE選單的「首頁」>「就診報到」，於自動報到機進行門診報到，自動報到機位置在一樓至三樓的櫃檯有放置。
                </li>
                <li>
                  「複診」 :
                  預約麻醉諮詢、超音波影像、快速門診、VIP特約門診、營養諮詢，請您前來報到時至一樓或三樓櫃檯抽取號碼牌，等候櫃檯叫號辦理門診報到。
                </li>
              </ul>
            </div>
            <AppointmentTimeSlots />
            <div class="btns">
              <a class="btn" href="https://www.musoonclinic.com.tw"
                ><p>返回官網</p></a
              >
              <a
                class="btn line"
                href="https://lin.ee/0Sp9KtA"
                style="background-color: #00C300;"
                ><div class="inner">
                  <img src="@/assets/images/icon_line.svg" />
                  <p>加入官方帳號</p>
                </div></a
              >
            </div>
          </template>
        </div>
      </div>
    </div>
  </template>

  <modal
    v-if="modal.display"
    @close="closeModal"
    @understand="closeModal"
    @makeOthers="makeOthers"
    :modalSetting="modalSetting"
  >
    <template v-slot:header v-if="modal.header">{{ modal.header }}</template>
    <template v-slot:body>{{ modal.body }} </template>
  </modal>

  <debug v-if="debug">
    {{ from.path }}
    <hr />
    {{ member }}
  </debug>
</template>

<script>
import AppointmentDepts from "../components/Appointment/Depts.vue";
import AppointmentDoctors from "../components/Appointment/Doctors.vue";
import AppointmentWeek from "../components/Appointment/Week.vue";
import AppointmentPeriod from "../components/Appointment/Period.vue";
import AppointmentTimeSlots from "../components/Appointment/TimeSlots.vue";
import Banner from "../components/Banner.vue";
import liff from "@line/liff";
import api from "../api/index";

export default {
  components: {
    AppointmentDepts,
    AppointmentDoctors,
    AppointmentWeek,
    AppointmentPeriod,
    AppointmentTimeSlots,
    Banner
  },
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      loading: true,
      modal: {},
      modalSetting: {},
      view: "dept",
      selectedDoctor: {},
      selectedWeek: 0,
      weekdates: [],
      schedules: [], //全部班表
      reservation: {}, //預約資訊
      appointment: {}, //預約結果
      qrcode: null,
      form: {}
    };
  },
  created() {
    this.getSchedules();
    this.modal = {
      display: true,
      header: "掛號注意事項",
      body: [
        "1. 網路掛號前，請點選按鈕「首頁」進行會員驗證（尚未掛號者請先預約）。",
        "2. 網路掛號提供四週內及當診的預約掛號。",
        "3. 婦產科初診掛號，請務必填寫初診單。",
        "4. 看診報到：已綁定LINE會員者，請開啟掃描QR Code工具，掃描自動報到機的QR Code後完成看診報到程序。\n＊自動報到機放置在1F、3F櫃檯。",
        "5. 取消預約：請於看診前一日使用官網或Line@線上取消，若欲取消當日預約，請來電取消。",
        "6. 當您無法順利完成網路掛號，請來電預約 02-25012312。",
        "7. 小兒科依照報到順序看診預約號次非看診號次請家長注意！\n看診當天自動報到後請務必將寶寶健康手冊及健保卡交給小兒科護理師。"
      ].join("\n")
    };
    this.modalSetting = {
      isShowUnderstand: true,
      noClose: true
    };
  },
  computed: {
    member() {
      return this.$store.state.member;
    },
    from() {
      return this.$store.state.from;
    },
    isMobile() {
      return this.member.platform.match(/^(line|develop)$/);
    },
    notFromLine() {
      return !this.from.includes("/Appointment");
    },
    noheader() {
      return this.isMobile ? "noheader" : null;
    },
    filterSchedules() {
      let result = {};
      //科別
      result = this.schedules.filter(s => s.科別 === this.selectedDoctor.dept);
      //週期
      result = result.filter(s => s.week === this.selectedWeek);
      //醫師
      if (this.selectedDoctor.name !== false)
        result = result.filter(s => s.醫師名 === this.selectedDoctor.name);

      return result;
    },
    currentDate() {
      if (this.weekdates.length === 0) return {};
      let current = this.weekdates.filter(s => s.week === this.selectedWeek);
      //console.log(current);
      return {
        year: current[0].year,
        month: current[0].month
      };
    },
    currentPatient() {
      if (this.member.info.child) {
        if (this.member.info.current === this.member.info.patientNo) {
          return this.member.info;
        } else {
          const child = this.member.info.child.find(
            c => c.patientNo === this.member.info.current
          );
          child.phone = this.member.info.phone; //小孩用媽媽手機預約
          return child;
        }
      } else {
        return this.member.info;
      }
    },
    clickCalendar() {
      const date = this.reservation.日期.split("-").join("");

      const shiftToTime = {
        早班: date + "T090000/" + date + "T120000",
        午班: date + "T140000/" + date + "T173000",
        晚班: date + "T183000/" + date + "T213000"
      };

      const time = shiftToTime[this.reservation.班別];
      const title =
        this.reservation.醫師名 +
        "醫師" +
        this.reservation.診別 +
        "，預約號碼：" +
        this.reservation.就診參考序號;

      return (
        "https://www.google.com/calendar/render?action=TEMPLATE&text=" +
        title +
        "&dates=" +
        time +
        "&location=台北市中山區長安東路二段90號"
      );
    },
    suggestedCheckInTime() {
      const resv = this.reservation;
      const apt = this.appointment;
      if (resv.診別.indexOf("影像") >= 0) return "請洽院所";
      switch (true) {
        // 婦產科
        case resv.科別 === "婦產科" && resv.班別 === "早" && apt.掛號序號 <= 5:
          return "09:30 前";
        case resv.科別 === "婦產科" && resv.班別 === "早" && apt.掛號序號 <= 20:
          return "10:30 前";
        case resv.科別 === "婦產科" && resv.班別 === "早":
          return "12:00 前";
        case resv.科別 === "婦產科" && resv.班別 === "午" && apt.掛號序號 <= 5:
          return "14:30 前";
        case resv.科別 === "婦產科" && resv.班別 === "午" && apt.掛號序號 <= 20:
          return "15:30 前";
        case resv.科別 === "婦產科" && resv.班別 === "午":
          return "17:00 前";
        case resv.科別 === "婦產科" && resv.班別 === "晚" && apt.掛號序號 <= 5:
          return "19:00 前";
        case resv.科別 === "婦產科" && resv.班別 === "晚" && apt.掛號序號 <= 20:
          return "20:00 前";
        case resv.科別 === "婦產科" && resv.班別 === "晚":
          return "21:30 前";
        // 小兒科
        case resv.科別 === "小兒科" && resv.班別 === "早" && apt.掛號序號 <= 39:
          return "09:00 ~ 10:30";
        case resv.科別 === "小兒科" && resv.班別 === "早":
          return "12:00 前";
        case resv.科別 === "小兒科" && resv.班別 === "午" && apt.掛號序號 <= 39:
          return "14:00 ~ 15:30";
        case resv.科別 === "小兒科" && resv.班別 === "午":
          return "16:30 前";
        case resv.科別 === "小兒科" && resv.班別 === "晚" && apt.掛號序號 <= 39:
          return "18:30 ~ 20:00";
        case resv.科別 === "小兒科" && resv.班別 === "晚":
          return "21:00 前";
        default:
          return null;
      }
    }
  },
  mounted() {
    //this.loading = false;
    this.selectedDoctor = {
      dept: this.member.params.dept,
      name: this.member.params.doctor
    };
    this.view = this.selectedDoctor.dept === false ? "home" : "schedule";
    console.log();
  },
  methods: {
    closeModal() {
      this.modal = {};
      this.modalSetting = {};
    },
    getSchedules() {
      api.appointment
        .schedule({
          jwt: this.member.jwt
        })
        .then(data => {
          console.log("醫師班表", data);
          if (!this.member.info.beta) {
            data.schedules = data.schedules.filter(
              s => s.院所代碼 !== "3501109998"
            );
          }
          console.log("醫師班表", data.schedules);
          this.schedules = data.schedules;
          this.weekdates = data.weekdates;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },
    btnForm() {
      if (this.member.info.verified) {
        //複診 自動帶入個人資料
        this.form = {
          patientNo: this.currentPatient.patientNo,
          name: this.currentPatient.name,
          twid: this.currentPatient.twid,
          birthdate: this.currentPatient.birthdate,
          phone: this.currentPatient.phone
        };
      } else {
        //初診 預設國籍 disabled
        this.form = {
          nation: "disabled"
        };
      }
      this.view = "form";
    },
    btnDoctor(dept, doctor) {
      let url = `https://www.musoonclinic.com.tw/team/${dept}/detail/${doctor}`;
      liff.openWindow({
        url,
        external: true
      });
    },
    btnMake() {
      if (!this.member.info.verified) {
        //檢查欄位姓名
        if (!this.form.name) {
          this.modal = {
            display: true,
            body: "請輸入您的姓名。"
          };
          return false;
        }
        if (!this.form.twid || !/^\w{5,20}$/.test(this.form.twid)) {
          this.modal = {
            display: true,
            body: "身分證格式錯誤，證件號碼需5~20英數字。"
          };
          return false;
        }
        if (
          !/^(19|20)\d\d(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])$/.test(
            this.form.birthdate
          )
        ) {
          this.modal = {
            display: true,
            body: "生日格式錯誤，應為西元年月日共8位數字。"
          };
          return false;
        }
        if (!/^09\d{8}$/.test(this.form.phone)) {
          this.modal = {
            display: true,
            body: "手機格式錯誤，需為09開頭，共10位數字。"
          };
          return false;
        }
        if (this.form.address === undefined || this.form.address.length < 10) {
          this.modal = {
            display: true,
            body: "請輸入完整地址。"
          };
          return false;
        }
        if (this.form.nation === "disabled") {
          this.modal = {
            display: true,
            body: "請選擇國籍。"
          };
          return false;
        }
      } //if !verified
      //送出
      this.loading = true;
      api.appointment
        .make({
          jwt: this.member.jwt,
          form: this.form,
          reservation: this.reservation
        })
        .then(data => {
          console.log(data);
          this.loading = false;
          this.qrcode = data.qr;
          this.appointment = data.appointment;
          this.view = "made";
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },
    btnHome() {
      this.selectedDoctor.dept = false;
      this.view = "home";
    },
    selectAll(dept) {
      this.selectedDoctor = { name: false, dept: dept };
      this.view = "schedule";
    },
    changeDept(dept) {
      console.log(dept);
      switch (dept) {
        case "婦產科":
        case "小兒科":
        case "營養科":
        case "皮膚科":
          this.selectedDoctor.dept = dept;
          this.view = "schedule";
          break;

        case "麻醉諮詢門診":
        case "超音波影像門診":
        case "快速門診":
          this.modal = {
            display: true,
            header: dept,
            body:
              "很抱歉，此科別尚未開放網路預約，請您來電預約，電話請撥：02-2501-2312。"
          };
          this.modalSetting = {
            isShowTel: true,
            telNumber: "02-25012312"
          };
          break;

        case "VIP 特約門診":
          this.$router.replace("/VIPReservation");
          return true;

        case "課程預約":
          this.modal = {
            display: true,
            header: dept,
            body: "很抱歉，此科別尚未開放網路預約，請您Line預約。"
          };
          this.modalSetting = {
            isShowUrl: true,
            urlTitle: "Line 預約",
            url: "https://line.me/ti/p/NhduE_4Tk5"
          };
          break;

        case "乳房醫學":
        case "醫美":
        case "外科":
          liff.openWindow({
            url: "https://line.me/ti/p/@louvre88",
            external: true
          });
          break;

        default:
          this.modal = {
            display: true,
            header: dept,
            body:
              "很抱歉，此科別尚未開放網路預約，請您來電預約，電話請撥：02-2501-2312。"
          };
          this.modalSetting = {
            isShowTel: true,
            telNumber: "02-25012312"
          };
          break;
      }
    },
    changeDoctor(doctor) {
      this.selectedDoctor = doctor;
    },
    changePeriod(period) {
      if (!period.enable) {
        const others = this.schedules.filter(
          schedule =>
            schedule.enable === true &&
            schedule.日期 === period.日期 &&
            schedule.科別 === period.科別 &&
            schedule.班別 === period.班別
        );
        console.log("同時段其它醫師", others);
        if (others.length === 0) {
          this.modalSetting = {
            isShowTel: true,
            telNumber: "0225012312"
          };
          this.modal = {
            display: true,
            header: "當班已截止網路預約",
            body: "請改約其他門診時間"
          };
          return;
        }
        this.modalSetting = {
          telNumber: "0225012312",
          period,
          schedules: others
        };
        const note = this.appointmentTime(period);
        this.modal = {
          display: true,
          header: "此時段尚有其他名額",
          body:
            `同時段尚有其他名額，請問是否進行預約\n ${period.日期} 星期${period.day} ${period.班別}診\n` +
            `看診時間 ${note.range} 最晚報到時間 ${note.last}`
        };
        return;
      }
      console.log("預約資訊", period);
      this.reservation = period;
      this.view = "reservation";
    },
    makeOthers(period) {
      console.log("改掛其他門診", period);
      this.reservation = period;
      this.view = "reservation";
      this.closeModal();
    },
    appointmentTime(period) {
      switch (period.班別) {
        case "早":
          return { range: "09:00 ~ 12:30", last: "12:00" };
        case "午":
          return { range: "13:30 ~ 17:00", last: "16:30" };
        case "晚":
          return { range: "18:00 ~ 21:30", last: "21:00" };
      }
    },
    changeWeek(offset) {
      this.selectedWeek += offset;
      this.selectedWeek = this.selectedWeek < 0 ? 0 : this.selectedWeek;
      this.selectedWeek = this.selectedWeek >= 4 ? 4 : this.selectedWeek;
      //console.log(this.selectedWeek);
    },
    cssWeek(offset) {
      if (offset > 0) {
        return this.selectedWeek === 4 ? "btn disabled" : "btn";
      } else {
        return this.selectedWeek === 0 ? "btn disabled" : "btn";
      }
    }
  }
};
</script>

<style scoped>
ul {
  margin: 2rem;
  list-style-type: disc;
}
li {
  /* margin-bottom: 2rem; */
  line-height: 1.6rem;
}
.formBox .inputBox:disabled {
  color: #000;
}
</style>
